import { render, staticRenderFns } from "./WylieReference.vue?vue&type=template&id=199db28d&scoped=true"
import script from "./WylieReference.vue?vue&type=script&lang=js"
export * from "./WylieReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199db28d",
  null
  
)

export default component.exports